import { useEffect, useRef, useState } from 'react'

const useHideOnScroll = (pixelsBeforeUp = 3, container?: HTMLDivElement) => {
  const [hiddenFromScroll, setHiddenFromScroll] = useState(false)

  const stoppedPosition = useRef<number>(0)
  const scrollPosition = useRef<number>(0)

  const scrollListener = useRef<(e: Event) => void>(() => null)
  const scrollSetterTimeout = useRef<ReturnType<typeof setTimeout>>()

  useEffect(() => {
    // @ts-ignore
    const scrollContainer = container?.current || window

    scrollContainer.removeEventListener('scroll', scrollListener.current)

    scrollListener.current = (_e: Event) => {
      const scrollFromTop = document.documentElement.scrollTop

      const scrollingDown = scrollPosition.current < scrollFromTop + pixelsBeforeUp
      scrollPosition.current = scrollFromTop >= 0 ? scrollFromTop : 0 // used To tell the scroll direction

      if (scrollSetterTimeout.current) clearTimeout(scrollSetterTimeout.current)

      scrollSetterTimeout.current = setTimeout(() => {
        stoppedPosition.current = scrollFromTop >= 0 ? scrollFromTop : 0
      }, 50)

      // These are the states we already want, if these are set leave them alone
      if (scrollingDown && hiddenFromScroll) return
      if (!scrollingDown && !hiddenFromScroll) return

      if (scrollingDown && scrollPosition.current - pixelsBeforeUp > stoppedPosition.current) setHiddenFromScroll(true)
      if (!scrollingDown && scrollPosition.current + pixelsBeforeUp < stoppedPosition.current)
        setHiddenFromScroll(false)
    }

    scrollContainer.addEventListener('scroll', scrollListener.current)

    return () => scrollContainer.removeEventListener('scroll', scrollListener.current)
  }, [hiddenFromScroll])

  return hiddenFromScroll
}

export default useHideOnScroll
